import ButtonDecor from '../../prefabs/global/pointandclick/ButtonDecor.js';
import AbstractScene from '../AbstractScene.js';
import PopUpDecor from '../../prefabs/global/pointandclick/PopUpDecor.js';
import SauvegardeManager from '../../prefabs/SauvegardeManager.js';
import { Colors } from '../../consts/Colors.js';
import PopUpBlue from '../../prefabs/global/popup/PopUpBlue.js';
import FONTS from '../../consts/Fonts.js';
import ButtonRounded from '../../prefabs/global/buttons/ButtonRounded.js';
import SoundManager from '../../prefabs/SoundManager.js';
import ReponsePopUp from '../../prefabs/global/ordi/ReponsePopUp.js';
import { tags } from '../../consts/Tags.js';

export default class PointAndClick extends AbstractScene {

    init(data) {
        this._init(data);

        this.config = this.cache.json.get('config')[this.scene.key];

        this.sauvegardeManager = new SauvegardeManager()
        this.sauvegardeManager.setCurrentChapter(this.scene.key);

        this.soundManager = new SoundManager();
        this.soundManager.stopAllLoops()
        this.soundManager.playAudio(this.audioName); // Defini dans l'init du chapitre

        // Load progression data
        this.chapitreProgression = this.sauvegardeManager.getChapitreProgression(this.scene.key)
        console.log(this.scene.key + " progression data :", this.chapitreProgression);
        if(!this.chapitreProgression){
            this.chapitreProgression = this.config.progression;
            console.log(this.scene.key + " progression data updated :", this.chapitreProgression);
        }

        // Init variables
        this.buttons = []
        this.dataButtons = this.config.boutons
    }

    preload() {
        this._preload();
    }

    create(){
        // Ajout du fond
        this.background = this.add.image(0, 0, this.scene.key + '_background').setOrigin(0, 0);

        // Ajout des boutons
        this.dataButtons.forEach( (data, index) => {
            let button = new ButtonDecor(this, data.position.x, data.position.y, index)
            button.setAlpha(0)
            button.setScale(0.5)
            if(this.chapitreProgression.boutonsDecors[index] == 1){
                button.setViewed();
            }
            this.buttons.push(button)

            button.setClickFunction( (btnInstance) => {
                if(!btnInstance.isViewed){
                    btnInstance.setViewed();
                    this.chapitreProgression.boutonsDecors[btnInstance.id] = 1;
                    this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
                }

                if(data.type === null || data.type === undefined || data.type === ""){
                    this.openIndice( btnInstance.id );
                }else{
                    this.openIndiceSpecial( btnInstance.id, data );
                }
            } )
        } )

    }

    displayButtons(){
        this.buttons.forEach( (button, index) => {
            button.y+=10
            this.tweens.add({ 
                targets: button,
                alpha: 1,
                scale: 1,
                y: button.y - 10,
                duration: 500,
                ease: 'Back.easeOut',
                delay: index * 50
            })
        })
    }

    openIndice(id){
        if(this.popup)
            return

        this.blurBackground();

        let data = this.dataButtons[id];
        this.popup = new PopUpDecor(this, data.poupPosition.x, data.poupPosition.y, {
            imageKey: data.imageKey,
            description: data.description,
            textPosition: data.textPosition,
            textColor: Colors.Text[data.textColor],
            endFunction: () => {this.closePopup()}
        })

        this.popup.animIn()
    }

    closePopup(){
        this.unblurBackground();

        if(this.popup){
            this.popup.animOut( () => {
                this.popup.destroy(true);
                this.popup = null;
            });
        }

        if(this.ordi){
            this.ordi.animOut(() => {
                this.ordi.destroy(true);
                this.ordi = null;
            })
            this.soundManager.playAudio(this.audioName);
        }
        

        if(this.popupAide){
            this.hidePopUpAide();
        }

        if(this.questionPanel){
            this.closePanelQuestion();
        }
    }

    blurBackground(){
        this.tweens.add({
            targets: this.background,
            alpha: 0.5,
            duration: 200,
        });

        this.hideButtons();
    }

    unblurBackground(){
        this.tweens.add({
            targets: this.background,
            alpha: 1,
            duration: 200,
        });

        this.showButtons();
    }

    hideButtons(){
        this.tweens.add({
            targets: this.buttons,
            alpha: 0,
            duration: 200,
        });
    }

    showButtons(){
        this.tweens.add({
            targets: this.buttons,
            alpha: 1,
            duration: 200,
        });
    }

    addPopUpAide(text){
        console.log("addPopUpAide", text);
        if(this.popupAide)
            return

        console.log("addPopUpAide", text);
        this.rect = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.White).setOrigin(0);
        this.rect.setInteractive();
        this.rect.depth = 1000

        this.popupAide = new PopUpBlue(this, this.width/2, this.height/2, 650, 370)
        this.popupAide.depth = 1001

        let textElmt = this.add.rexTagText(0, 0, text, {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '28px',
            color: Colors.Text.White,
            align: 'center',
            wordWrap: { width: 536 }
        }).setOrigin(0.5, 0)

        this.popupAide.addElementToBody(textElmt, 40)

        let button = new ButtonRounded(this, 0, 0, {
            text: "J’ai compris",
            color: Colors.Elmt.White,
            borderColor: Colors.Elmt.White,
            borderHoverColor: Colors.Elmt.Blue,
            textColor: Colors.Text.Black,
            textHoverColor: Colors.Text.Blue
        })
        this.popupAide.addElementToBody(button, 40 + button.height/2 )
        button.setClickFunction( () => {
            this.hidePopUpAide();
        })

        this.popupAide.animIn()

        this.rect.setAlpha(0)
        this.tweens.add({
            targets: this.rect,
            alpha: 0.5,
            duration: 200,
        });
    }

    hidePopUpAide(){
        if(this.popupAide){
            this.popupAide.animOut( () => {
                this.popupAide.destroy(true);
                this.popupAide = null;
                this.rect.destroy(true);
                if(this.popup && this.popup.showArticle)
                    this.popup.showArticle();
            })
            this.tweens.add({
                targets: this.rect,
                alpha: 0,
                duration: 200,
            });
        }
    }

        // Rectangle Vrai/Faux qui s'affiche après validation de la réponse
    showReponsePopUp({text, isTrue, isLast = false, endFunc}){
        this.reponsePopup = new ReponsePopUp(this, this.width/2, this.height/2, {text, isTrue, isLast, endFunc})
        this.reponsePopup.animIn();
    }

    closeReponsePopUp(){
        this.reponsePopup.animOut()
    }

    popupFinChapitre(text, height, nextScene){
        this.blurBackground();
        
        this.popup = new PopUpBlue(this, this.width/2, this.height/2, 800, height)

        // Ajout text
        let textElmt = this.add.rexTagText(0, 0, text, {
            fontSize: "28px",
            fontFamily: FONTS.Inter28MediumItalic,
            wordWrap: {width: 702},
            backgroundColor: 'transparent',
            tags: tags
        }).setOrigin(0.5, 0)
        this.popup.addElementToBody(textElmt, 40)

        // Ajout bouton chapitre suivant
        let nextButton = new ButtonRounded(this, 0, 0, {
            text: "Chapitre suivant",
            color: Colors.Elmt.White,
            textColor: Colors.Text.Black,
            textHoverColor: Colors.Text.Blue,
            borderHoverColor: Colors.Elmt.Blue
        })
        this.popup.addElementToBody(nextButton, 40 + nextButton.height/2)
        nextButton.setClickFunction(() => {
            let rect = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.Black).setOrigin(0);
            rect.setAlpha(0)
            rect.depth = 1002
            this.tweens.add({
                targets: rect,
                alpha: 1,
                duration: 1000,
                onComplete: () => {
                    this.scene.start(nextScene)
                }
            })
        })

        this.popup.animIn()
    }

}